import { render, staticRenderFns } from "./PopupAddVenue.vue?vue&type=template&id=33660812&scoped=true&"
import script from "./PopupAddVenue.vue?vue&type=script&lang=js&"
export * from "./PopupAddVenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33660812",
  null
  
)

export default component.exports